import styled, { keyframes } from 'styled-components';
import { LoaderIcon } from 'src/common/images/LoaderIcon';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled(LoaderIcon)`
  animation: ${rotate} 2s linear infinite;

  path {
    stroke: ${({ theme }) => theme.colors.loader ?? '#282850'};
  }
`;
